import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const TextContainer = styled.div`
  display: flex !important;
`;

export const StyledLink = styled(Link)`
  text-decoration: none !important;
`;

export const HeaderText = styled.h3`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.headerThree} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  padding: ${props => `0 0 ${props.theme.space.s2}`} !important;
`;

export const SecondaryText = styled.p`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
`;

export const StatusText = styled.span`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  display: inline !important;

  ${props => props.theme.mediaQueries.medium} {
    font-size: ${props => props.theme.fontSizes.body} !important;
  }
`;

export const PhoneNumberText = styled.p`
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  display: inline !important;

  ${props => props.theme.mediaQueries.medium} {
    font-size: ${props => props.theme.fontSizes.body} !important;
  }
`;

export const InlineLinkText = styled.span`
  color: ${props => props.theme.colors.capsuleGreen60} !important;
  cursor: pointer;
`;

export const InstructionText = styled.p`
  font-family: ${props => props.theme.fonts.mercury} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.small} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  text-transform: uppercase !important;
  margin: ${props => props.theme.space['1.5']} 0 !important;
`;
